import{d as r}from"./chunk-V5UYV5M6.js";import{b as o}from"./chunk-IYPL54AU.js";import{m as t}from"./chunk-HBP5N4FR.js";t();function m(e){return r(n=>o(n,e))}export{m as a};
//# sourceMappingURL=chunk-ZOF5NKV2.js.map
